import React, { useLayoutEffect, useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Col, Row, Form, Container, Button, Spinner } from 'react-bootstrap'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { useNavigate, useParams } from 'react-router-dom'
import { IMaskInput } from 'react-imask'

import styles from './styles.module.css'

import ConfirmationModal from '../../../../components/ConfirmationModal'
import { useLoading } from '../../../../hooks/LoadingContext'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'

const MotoristasEditar: React.FC = () => {
  const [board, setBoard] = useState<string>('')
  const [model, setModel] = useState<string>('')
  const [color, setColor] = useState<string>('')
  const [capacity, setCapacity] = useState<number>()
  const [start_at, setStart_at] = useState<string>('')
  const [validated, setValidated] = useState<boolean>()
  useState<string>('')

  const [showModalValidate, setShowModalValidate] = useState(false)
  const handleCloseModalValidate = () => setShowModalValidate(false)
  const handleShowModalValidate = () => {
    setShowModalValidate(true)
  }

  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()
  let { id } = useParams()

  useLayoutEffect(() => {
    async function loadData() {
      setIsLoading(true)
      try {
        const { data } = await api.get(`/company/vehicles/${id}`)

        setBoard(data.board)
        setModel(data.model)
        setColor(data.color)
        setCapacity(data.capacity)
        setStart_at(data.start_at)
        setValidated(data.validated)
      } catch (err) {
        toast.error('Falha ao buscar os dados! Atualize a página.')
      }
      setIsLoading(false)
    }
    loadData()
  }, [id, setIsLoading])

  const handleChangeValidation = async (event: any) => {
    event.preventDefault()
    setIsLoading(true)

    try {
      await api.put(`/company/vehicles/${id}`, { validated: !validated })
      toast.info('Veículo atualizado com sucesso!', { autoClose: 3000 })
      setIsLoading(false)
      navigate('/empresa/veiculos')
    } catch (err) {
      setIsLoading(false)
      toast.error(errorApi(err, 'Falha ao invalidar o veículo! Tente novamente.'))
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!board || !model || !color || !capacity) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }
    try {
      await api.put(`/company/vehicles/${id}`, {
        board: board,
        model: model,
        color: color,
        capacity: capacity,
        start_at: start_at ? new Date(start_at).toISOString() : null,
      })

      setIsLoading(false)
      toast.info('Veículo atualizado com sucesso!', { autoClose: 3000 })
      navigate('/empresa/veiculos')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao atualizar o veículo! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return board && model && color && capacity;
  };
  
  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Editar veículo">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Editar dados do veículo</h2>
        <Col className={styles.form_container}>
          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Placa*
              </Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask="*******"
                placeholder="Digite aqui a placa"
                value={board}
                onChange={(event) => setBoard(event.target.value.toUpperCase())}
              />
            </Col>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Modelo*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o modelo do veículo"
                value={model}
                onChange={(event) => setModel(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Cor*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a cor do veículo"
                value={color}
                onChange={(event) => setColor(event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Capacidade de carga (Kg)*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a capacidade do veículo em quilos"
                value={capacity}
                onChange={(event) => setCapacity(Number(event.target.value) || 0)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Adquirido na data
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o estado"
                type="date"
                value={start_at}
                onChange={(event) => setStart_at(event.target.value)}
              />
            </Col>
          </Row>

          <Col style={{ textAlign: 'right' }}>
            {validated ? (
              <Button
                className={`${styles.button} ${styles.delete_button}`}
                disabled={isLoading}
                onClick={handleShowModalValidate}
              >
                Invalidar veículo
              </Button>
            ) : (
              <Button
                className={`${styles.button}`}
                disabled={isLoading}
                variant="success"
                onClick={handleShowModalValidate}
              >
                Validar veículo
              </Button>
            )}
            <Button
              className={`${styles.button} ${styles.submit_button}`}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Atualizar veículo'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
      <ConfirmationModal
        show={showModalValidate}
        message={`Tem certeza de que deseja ${validated ? 'invalidar' : 'validar'} o veículo?`}
        action={handleChangeValidation}
        closeModal={handleCloseModalValidate}
      ></ConfirmationModal>
    </DashboardLayout>
  )
}

export default MotoristasEditar
